import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../../hook/useRulesContext";
import FieldWrapper from "../../../../../../components/UI/common/FieldWrapper";
import ProductSelect from "../../../../../../components/UI/WC/ProductSelect";
import ProductCategorySelect from "../../../../../../components/UI/WC/ProductCategorySelect";
import ProductTagSelect from "../../../../../../components/UI/WC/ProductTagSelect";
import MultiSelect from "../../../../../../components/UI/MultiSelect";

export default function BasicSettings() {
    const {
        shortcodeFormData: formData,
        productTypes: availableProductTypes,
        handleInputChange,
    } = useRulesContext();

    return (
        <>
            <FieldWrapper
                label={__(
                    "Product Types",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Restrict to specific product types.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                direction="vertical"
                fieldsClass=""
            >
                <MultiSelect
                    name="product_types"
                    value={formData.product_types}
                    onChange={handleInputChange}
                    placeholder="Search product types"
                    options={availableProductTypes} // ← Pass options directly
                    // responseType="array" is default, no need to specify
                    isMulti={true}
                />
            </FieldWrapper>
            {/* Specific Products */}
            {formData.apply_to === "products" && (
                <FieldWrapper
                    label={__(
                        "Specific Products",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    description={__(
                        "Select individual products to apply this quantity rule.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    direction="vertical"
                    fieldsClass=""
                >
                    <ProductSelect
                        name="products"
                        value={formData.products}
                        onChange={handleInputChange}
                    />
                </FieldWrapper>
            )}

            {/* Specific Product Categories */}
            {formData.apply_to === "categories" && (
                <FieldWrapper
                    label={__(
                        "Specific Categories",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    description={__(
                        "Select individual product categories to apply this quantity rule.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    direction="vertical"
                    fieldsClass=""
                >
                    <ProductCategorySelect
                        name="categories"
                        value={formData.categories}
                        onChange={handleInputChange}
                    />
                </FieldWrapper>
            )}

            {/* Specific Product Tags */}
            {formData.apply_to === "tags" && (
                <FieldWrapper
                    label={__(
                        "Specific Tags",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    description={__(
                        "Select individual product tags to apply this quantity rule.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    direction="vertical"
                    fieldsClass=""
                >
                    <ProductTagSelect
                        name="tags"
                        value={formData.tags}
                        onChange={handleInputChange}
                    />
                </FieldWrapper>
            )}
        </>
    );
}
